import { motion, AnimatePresence } from "framer-motion";

/**
 * TypingIndicator — bolha do assistant com 3 pontinhos animados,
 * estilo WhatsApp. Substitui o spinner+label durante isLoading.
 *
 * Stagger: dot 1 (delay 0), dot 2 (delay 200ms), dot 3 (delay 400ms).
 * Duração 600ms por ciclo, scale 1 → 1.4 → 1, opacity 0.5 → 1 → 0.5.
 */
export default function TypingIndicator() {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, transition: { duration: 0.2 } }}
        transition={{ duration: 0.2 }}
        className="mr-4 mt-3"
        data-testid="typing-indicator"
      >
        {/* Texto sutil acima */}
        <p className="text-[11px] text-slate-500 mb-1 ml-1">Nexo está pensando...</p>

        {/* Bolha mesmo estilo do assistant */}
        <div className="relative inline-flex items-center gap-1.5 px-4 py-3 rounded-2xl
                        bg-nectar-card border border-nectar-border">
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className="block w-2 h-2 rounded-full bg-slate-400"
              animate={{ scale: [1, 1.4, 1], opacity: [0.4, 1, 0.4] }}
              transition={{
                duration: 0.6,
                repeat: Infinity,
                delay: i * 0.2,
                ease: "easeInOut",
              }}
            />
          ))}
          {/* Tail combinando com assistant */}
          <svg
            className="absolute bottom-0 -left-1.5 pointer-events-none"
            width="10" height="14" viewBox="0 0 10 14" aria-hidden="true"
          >
            <path d="M10 0 L10 14 L0 14 Z" fill="#0d1220" />
            <path d="M10 0 L0 14" stroke="#1F2A44" strokeWidth="1" fill="none" />
          </svg>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
